
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hideaway",
      function () {
        return require("private-next-pages/hideaway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hideaway"])
      });
    }
  